var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgContentCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "content_copy_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 21,
  height: 20
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M.5 0h20v20H.5z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#content_copy_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 15.001c-.458 0-.85-.163-1.177-.489a1.605 1.605 0 0 1-.49-1.177v-10c0-.459.164-.851.49-1.178.326-.326.719-.489 1.177-.489h7.5c.458 0 .85.163 1.177.49.327.326.49.718.49 1.177v10c0 .458-.163.85-.49 1.177-.326.326-.719.49-1.177.49H8Zm0-1.666h7.5v-10H8v10Zm-3.333 5c-.459 0-.851-.163-1.178-.49A1.607 1.607 0 0 1 3 16.669V5.835c0-.236.08-.435.24-.595.16-.159.357-.239.593-.239s.434.08.595.24c.159.16.239.358.239.594v10.833H13c.236 0 .434.08.594.24.16.16.24.357.24.593s-.08.434-.24.594a.807.807 0 0 1-.594.24H4.667Z",
  fill: "#fff"
}))));
export default SvgContentCopy;